module.exports = __webpack_public_path__ + "img/TUCANES.02091005.png";